<template>
  <div class="partner-box">
    <div class="en-title">COOPERATIVE PARTNER</div>
    <div class="cn-title">合作伙伴</div>
    <div class="content">
      <img src="@/assets/home/partner_img.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import url('./index.scss');
</style>
